export default __webpack_public_path__ + "static/media/cutout-trace.8d04f882.jpg";